<template>
  <van-row class="page-wrapper payment-history-page" justify="center">
    <van-col class="itserve-center payment-history-items" span="24">
      <template v-if="hasPaymentHistory">
        <template v-for="(message, index) in paymentHistory">
          <section :key="message.id || index" class="payment-history-card">
            <div class="payment-history-card__icon" aria-hidden="true">
              <svg viewBox="0 0 64 64">
                <rect x="12" y="16" width="40" height="36" rx="8" />
                <path d="M21 10v10M43 10v10M13 27h38" />
                <path d="M22 37h6M32 37h6M42 37h4M22 45h6M32 45h6" />
              </svg>
            </div>

            <div class="payment-history-card__content">
              <div class="payment-history-card__row">
                <span class="payment-history-card__label">
                  {{ $t("paymentHistorySearch.period") }}
                </span>
                <strong class="payment-history-card__value">
                  {{ message.last_date_month }}
                </strong>
              </div>

              <div class="payment-history-card__row">
                <span class="payment-history-card__label">
                  {{ $t("paymentHistorySearch.sum") }}
                </span>
                <strong
                  class="payment-history-card__value payment-history-card__amount"
                >
                  {{ message.amount_payments }} грн
                </strong>
              </div>
            </div>
          </section>
        </template>
        <div class="payment-history-bottom-spacer" aria-hidden="true"></div>
      </template>
      <template v-else>
        <div class="payment-history-empty place-content-center">
          <info-message>
            {{ $t("global.noData") }}
          </info-message>
        </div>
      </template>
    </van-col>
  </van-row>
</template>

<script>
import InfoMessage from "@/components/content/InfoMessage";

export default {
  name: "PaymentHistorySearchResults",
  components: { InfoMessage },
  computed: {
    hasPaymentHistory() {
      return (
        Array.isArray(this.paymentHistory) && this.paymentHistory.length > 0
      );
    },
    paymentHistory() {
      return this.$store.state.PaymentHistory.paymentHistory;
    },
  },
};
</script>

<style scoped>
.page-wrapper {
  min-height: 100%;
  background-color: transparent;
}

.payment-history-page {
  padding: 14px 0 44px;
}

.payment-history-items {
  width: calc(100% - 24px);
  max-width: 414px;
  margin: 0 auto;
  padding-bottom: 20px;
}

.payment-history-card {
  display: grid;
  grid-template-columns: 44px minmax(0, 1fr);
  gap: 12px;
  align-items: center;
  margin: 0 0 10px;
  padding: 13px 14px;
  border: 1px solid rgba(46, 74, 112, 0.58);
  border-radius: 12px;
  background: linear-gradient(
      145deg,
      rgba(16, 22, 34, 0.98),
      rgba(11, 16, 26, 0.98)
    ),
    #0e121b;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.035);
}

.payment-history-card__icon {
  width: 42px;
  height: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: rgba(35, 112, 255, 0.2);
  color: #ffffff;
}

.payment-history-card__icon svg {
  width: 29px;
  height: 29px;
  fill: none;
  stroke: currentColor;
  stroke-width: 3.1;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.payment-history-card__content {
  min-width: 0;
}

.payment-history-card__row {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;
  padding: 3px 0;
}

.payment-history-card__row + .payment-history-card__row {
  margin-top: 5px;
  padding-top: 9px;
  border-top: 1px solid rgba(45, 67, 98, 0.48);
}

.payment-history-card__label {
  min-width: 0;
  color: rgba(255, 255, 255, 0.72);
  font-size: 14px;
  font-weight: 650;
  line-height: 1.2;
}

.payment-history-card__value {
  flex: 0 0 auto;
  color: #ffffff;
  font-size: 16px;
  font-weight: 850;
  line-height: 1.15;
  text-align: right;
}

.payment-history-card__amount {
  color: #5ee56b;
}

.payment-history-empty {
  padding: 24px 12px;
}

.payment-history-bottom-spacer {
  width: 100%;
  height: calc(124px + env(safe-area-inset-bottom, 0px));
  flex: 0 0 auto;
}

@media (max-width: 360px) {
  .payment-history-items {
    width: calc(100% - 16px);
  }

  .payment-history-card {
    grid-template-columns: 38px minmax(0, 1fr);
    gap: 10px;
    padding: 12px 11px;
  }

  .payment-history-card__icon {
    width: 38px;
    height: 38px;
  }

  .payment-history-card__icon svg {
    width: 26px;
    height: 26px;
  }

  .payment-history-card__label {
    font-size: 13px;
  }

  .payment-history-card__value {
    font-size: 15px;
  }
}
</style>
